import * as React from "react";
import { CommonHelper } from "../../../../../../../../react-core/Helpers/CommonHelper";
import { CheckboxEditor } from "../../../../../../../../react-core/Html/CheckboxEditor";
import { RadiosEditor } from "../../../../../../../../react-core/Html/RadiosEditor";
import { SelectEditor } from "../../../../../../../../react-core/Html/SelectEditor";
import { AssetClassType } from "../../../../../../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { MPSType } from "../../../../../../../../Wrap/Constants/Enums/Domain/Instrument/MPSType";
import { PerformanceMethod } from "../../../../../../../../Wrap/Constants/Enums/Domain/PerformanceMethod";
import { ViewType } from "../../../../../../../../Wrap/Constants/Enums/Portfolio/Investments/ViewType";
import { ReportContent } from "../../../../../../../../Wrap/Constants/Enums/Report/ReportContent";
import { ReportPerformanceGraph } from "../../../../../../../../Wrap/Constants/Enums/Report/ReportPerformanceGraph";
import { ClientAccount } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { Benchmark } from "../../../../../../../../Wrap/Models/Models/Benchmarks/Benchmark";
import { ReportBuilder } from "../../../../../../../../Wrap/Models/Models/Reports/ReportBuilder";
import { CheckboxGroup } from "../../../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { AssetClassTypeMap, AssetClassTypeArray, MPSTypeArray, MPSTypeMap } from "../../Performance/Resource/Contents";
import { ClientReportAction } from "../Action/ClientReportAction";
import { ViewTypeArray, ViewTypeMap } from "../Resource/Content";
import { ClientReportPortfolio } from "./ClientReportPortfolio";

interface IPerferenceProps extends IProcessComponentProps {
    clientAccount: ClientAccount;
    data: ReportBuilder;
}

interface IPerferenceState {
    hasBenchmark: boolean;
    oneBenchmark: boolean;
    benchmarks: Array<Benchmark>;
}

export class Perference extends ProcessComponent<IPerferenceProps, IPerferenceState> {
    constructor(props: IPerferenceProps) {
        super(props);
        this.state = {
            hasBenchmark: false,
            oneBenchmark: true,
            benchmarks: null,
        };
    }

    render() {
        const { data, onChange } = this.props;
        const showCalculationBasis =
            data.ReportContents.includes(ReportContent.Performance) ||
            data.ReportContents.includes(ReportContent.Snapshot);
        const showPerformanceValuation =
            data.ReportContents.includes(ReportContent.Performance) ||
            data.ReportContents.includes(ReportContent.Valuation);
        const options = [];
        if (data.ReportContents.includes(ReportContent.Valuation)) {
            options.push({
                label: "Valuation",
                cssWrapper: "square-checkbox ",
                value: data?.ValuationIncludeFundBreakdown,
                onChange: (v) => {
                    if (!v) {
                        onChange({
                            ValuationIncludeFundBreakdown: v,
                            ViewType: data?.PerformanceIncludeFundBreakdown == true ? data?.ViewType : ViewType.Product,
                            AssetClassType:
                                data?.PerformanceIncludeFundBreakdown == true
                                    ? data?.AssetClassType
                                    : AssetClassType.NoAssetClass,
                        });
                    } else {
                        onChange({ ValuationIncludeFundBreakdown: v });
                    }
                },
            });
        }
        if (data.ReportContents.includes(ReportContent.Performance)) {
            options.push({
                label: "Performance",
                cssWrapper: "square-checkbox ",
                value: data?.PerformanceIncludeFundBreakdown,
                onChange: (v) => {
                    if (!v) {
                        onChange({
                            PerformanceIncludeFundBreakdown: v,
                            ViewType: data?.ValuationIncludeFundBreakdown == true ? data?.ViewType : ViewType.Product,
                            AssetClassType:
                                data?.ValuationIncludeFundBreakdown == true
                                    ? data?.AssetClassType
                                    : AssetClassType.NoAssetClass,
                        });
                    } else {
                        onChange({ PerformanceIncludeFundBreakdown: v });
                    }
                },
            });
        }

        const showGraphBenchmark =
            data.ReportContents.includes(ReportContent.Performance) &&
            (data.ReportPerformanceGraphs.includes(ReportPerformanceGraph.CumulativePerformance) ||
                data.ReportPerformanceGraphs.includes(ReportPerformanceGraph.DiscretePerformance));
        const showPerferences = showGraphBenchmark || showPerformanceValuation || showCalculationBasis;
        if (!showPerferences) {
            return null;
        }
        return (
            <ClientReportPortfolio>
                <h2>Preferences</h2>
                {showCalculationBasis && (
                    <>
                        <h3>Calculation basis</h3>
                        <RadiosEditor
                            options={[PerformanceMethod.Simple, PerformanceMethod.IRR]}
                            getText={(o) =>
                                o == PerformanceMethod.Simple ? "Simple return" : "Internal rate of return"
                            }
                            selected={data?.PerformanceMethod}
                            onChange={(v) =>
                                onChange({
                                    PerformanceMethod: v,
                                })
                            }
                            required="Please select"
                            cssWrapper="rg-inline"
                        />
                    </>
                )}
                {showPerformanceValuation && (
                    <>
                        <br />
                        <h3>{"Valuation & performance detail"}</h3>
                        <fieldset className="form-group checkbox-layout-vertical mb-0">
                            <CheckboxGroup type="inline" options={options} title="Include fund breakdown" />
                        </fieldset>

                        {(data.ValuationIncludeFundBreakdown || data?.PerformanceIncludeFundBreakdown) && (
                            <>
                                <RadiosEditor
                                    options={ViewTypeArray}
                                    getText={(o) => ViewTypeMap[o]}
                                    selected={data?.ViewType}
                                    onChange={(v) =>
                                        onChange({
                                            ViewType: v,
                                        })
                                    }
                                    required="Please select"
                                    cssWrapper="rg-150 mb-10 text-link"
                                />

                                <RadiosEditor
                                    options={AssetClassTypeArray}
                                    getText={(o) => AssetClassTypeMap[o]}
                                    selected={data?.AssetClassType}
                                    onChange={(v) =>
                                        onChange({
                                            AssetClassType: v,
                                        })
                                    }
                                    required="Please select"
                                    cssWrapper="rg-150 mb-10 text-link"
                                />

                                <RadiosEditor
                                    options={MPSTypeArray}
                                    getText={(o) => MPSTypeMap[o]}
                                    tooltip={"If the investments include Managed Portfolio(s), you have the choice of showing a Summary view - MPS total(s) only, or a Detail view – MPS underlying funds and total(s)."}
                                    selected={data?.MPSType}
                                    onChange={(v) =>
                                        onChange({
                                            MPSType: v,
                                        })
                                    }
                                    required="Please select"
                                    cssWrapper="rg-150 mb-10 text-link"
                                />
                            </>
                        )}
                    </>
                )}
                {showGraphBenchmark && (
                    <>
                        <br />
                        <h3>{"Graph benchmark"}</h3>
                        <CheckboxEditor
                            label={"Add performance benchmark(s)"}
                            cssWrapper="square-checkbox "
                            value={this.state.hasBenchmark}
                            onChange={(v) => {
                                if (this.state.benchmarks == null) {
                                    ClientReportAction.getAvailableBenchmarks((res) => {
                                        this.setState({ benchmarks: res, hasBenchmark: v });
                                    });
                                } else {
                                    this.setState({ hasBenchmark: v });
                                }

                                if (!v) {
                                    this.props.onChange({ BenchmarkList: [] });
                                }
                            }}
                        />
                        {this.state.hasBenchmark && (
                            <>
                                <RadiosEditor
                                    options={[true, false]}
                                    getText={(o) => (o ? "Include one benchmark" : "Include two benchmarks")}
                                    onChange={(v) => {
                                        this.setState({ oneBenchmark: v });
                                    }}
                                    cssWrapper={"radio-group rg-inline mb-0"}
                                    selected={this.state.oneBenchmark}
                                />
                                <div className="row">
                                    <div className="col-6">
                                        <SelectEditor
                                            options={this.state.benchmarks ? this.state.benchmarks : []}
                                            getText={(o) => o.BenchmarkDisplayName}
                                            onChange={(v) => {
                                                const benchMark = this.props.data.BenchmarkList.concat();
                                                benchMark[0] = v.BenchmarkCode;
                                                this.props.onChange({ BenchmarkList: benchMark });
                                            }}
                                            required="Please select"
                                            placeholder="Select benchmark one"
                                            validationRules={[
                                                {
                                                    errorMessage: "Cannot select the same benchmark twice",
                                                    validator: (v) => {
                                                        return (
                                                            this.props.data.BenchmarkList[0] !=
                                                                this.props.data.BenchmarkList[1] ||
                                                            CommonHelper.isNullOrEmpty(
                                                                this.props.data.BenchmarkList[0]
                                                            ) ||
                                                            CommonHelper.isNullOrEmpty(this.props.data.BenchmarkList[1])
                                                        );
                                                    },
                                                },
                                            ]}
                                        />
                                    </div>
                                    {!this.state.oneBenchmark && (
                                        <div className="col-6">
                                            <SelectEditor
                                                options={this.state.benchmarks ? this.state.benchmarks : []}
                                                getText={(o) => o.BenchmarkDisplayName}
                                                onChange={(v) => {
                                                    const benchMark = this.props.data.BenchmarkList.concat();
                                                    benchMark[1] = v.BenchmarkCode;
                                                    this.props.onChange({ BenchmarkList: benchMark });
                                                }}
                                                required="Please select"
                                                placeholder="Select benchmark two"
                                                validationRules={[
                                                    {
                                                        errorMessage: "Cannot select the same benchmark twice",
                                                        validator: (v) => {
                                                            return (
                                                                this.props.data.BenchmarkList[0] !=
                                                                    this.props.data.BenchmarkList[1] ||
                                                                CommonHelper.isNullOrEmpty(
                                                                    this.props.data.BenchmarkList[0]
                                                                ) ||
                                                                CommonHelper.isNullOrEmpty(
                                                                    this.props.data.BenchmarkList[1]
                                                                )
                                                            );
                                                        },
                                                    },
                                                ]}
                                            />
                                        </div>
                                    )}
                                </div>
                            </>
                        )}
                    </>
                )}
            </ClientReportPortfolio>
        );
    }
}
